import { useParamsSearch } from '@anytag/shared-hooks';
import { MarketplaceCampaignsSearchSchemaType } from '../schemaTypes';

export const useMarketplaceCampaignsFilter = () => useParamsSearch<MarketplaceCampaignsSearchSchemaType>();
